import React from 'react';

import mulchLogo from '../../assets/images/logo.png';
import classes from './Logo.css';

const logo = (props) => (
    <div className={classes.Logo} style={{height: props.height}}>
        <img src={mulchLogo} alt="Mulch 2.0" />
    </div>
);

export default logo;


// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js